export default __webpack_public_path__ + "static/media/pre-op-5.1f85a2d0.jpg";